import "./whatsapp-chat-status.css";

export function WhatsAppChatStatus({ status, openWhatsApp }: {
  status?: string | null | undefined;
  openWhatsApp?: (() => void) | undefined;
}) {
  // WHY [BOL-CHAT-WHATSAPP-STATUS-865]: an unreadable or changing connection is
  // not confirmed disconnection. This is labelled UI status, not an assistant
  // turn; it neither changes history nor prevents ordinary questions.
  if ((status !== "DISCONNECTED" && status !== "SCAN_REQUIRED") || !openWhatsApp) return null;
  return <aside className="ops-whatsapp-chat-status" aria-label="WhatsApp connection status">
    <strong>WhatsApp connection</strong>
    <p role="status">WhatsApp is disconnected. I can still help with your question.</p>
    <button type="button" onClick={openWhatsApp}>Connect WhatsApp</button>
  </aside>;
}
